export default __webpack_public_path__ + "static/media/g2022-17.ceb77a78.jpeg";